import * as React from "react";
import styled from "styled-components";

import i18n from "../../lib/i18n";
import Translate from "../../common/components/Translate";
import Sticky, { StickyChildrenFunc } from "../../common/components/Sticky";
import { PrimaryButton, LinkButton } from "../../common/components/buttons";

interface Props {
  isDirty: boolean;
  isSaving: boolean;
  locale: string;
  onPublish(): void;
  onCancel(): void;
}

class DraftActions extends React.PureComponent<Props> {
  constructor(props: Props) {
    super(props);
  }

  public componentDidMount() {
    window.addEventListener("beforeunload", this.beforeUnload);
  }

  public componentWillUnmount() {
    window.removeEventListener("beforeunload", this.beforeUnload);
  }

  public beforeUnload = (event: BeforeUnloadEvent) => {
    const { locale } = this.props;
    if (this.props.isDirty) {
      const confirmationMessage = i18n.t("company.draft_actions.warning_before_unload", { locale });
      event.returnValue = confirmationMessage;
      return confirmationMessage;
    }
    return undefined;
  };

  public render() {
    const { isDirty } = this.props;
    if (!isDirty) {
      return null;
    }
    return <Sticky>{this.renderWithSticky}</Sticky>;
  }

  public renderWithSticky: StickyChildrenFunc = ({ isSticky, ref }) => {
    const { isSaving, onPublish, onCancel } = this.props;
    return (
      <Inner id={"draftactions-inner"} innerRef={ref} isSticky={isSticky}>
        <Msg>
          <Translate id="company.draft_actions.has_unsaved_changes" />
        </Msg>
        <CancelButton type="button" onClick={onCancel}>
          <Translate id="company.draft_actions.cancel" />
        </CancelButton>
        <ButtonBg>
          <PublishButton disabled={isSaving} onClick={onPublish}>
            {isSaving ? (
              <Translate id="company.draft_actions.saving" />
            ) : (
              <Translate id="company.draft_actions.publish" />
            )}
          </PublishButton>
        </ButtonBg>
      </Inner>
    );
  };
}

interface StyleProps {
  isSticky: boolean;
}

const Inner = styled.div`
  position: ${(p: StyleProps) => (p.isSticky ? "fixed" : "relative")};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 1101; /* Global header has z-index 1100 */
  width: 100%;
  padding: 13px 30px;
  box-sizing: border-box;
  background-image: linear-gradient(to left, #1e7dde, #00c4c4);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.06);
`;

const Msg = styled.div`
  margin-left: auto;
  font-weight: 400;
  font-size: 13px;
  color: white;
`;

const ButtonBg = styled.div`
  margin-left: 15px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 100px;
  overflow: hidden;
  &:hover {
    background-color: white;
  }
`;

const PublishButton = PrimaryButton.extend`
  font-weight: 600;
  background: unset;
  &:hover {
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    transform: translateY(0);
  }
`;

const CancelButton = styled(LinkButton)`
  margin-left: 40px;
  color: white;
  font-weight: 400;
`;

export default DraftActions;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/DraftActions.tsx